import React from 'react'
import { useTranslation } from 'react-i18next'
import { IconHotel, IconFlight, IconBlog, IconMotel, IconBusiness, IconHunting } from '../../constants/icons'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'

interface iProps {}

const HeaderNav: React.FC<iProps> = () => {
    const { t } = useTranslation(['hotel', 'flight', 'common'])
    const { pathname } = useLocation()

    const renderActive = (arrPath: string[]) => {
        return arrPath.includes(pathname) ? 'active' : ''
    }

    return (
        <div className="header__navbar">
            <div className="container">
                <nav className="navbar">
                    <ul>
                        <li className={renderActive(['/'])}>
                            <Link to={'/'}>
                                <IconHunting />
                                <span>Săn giá rẻ</span>
                            </Link>
                        </li>
                        <li className={renderActive(['/tim-khach-san', '/hotel/vn/[id]', '/khach-san'])}>
                            <a href="https://www.vntrip.vn/khach-san">
                                <IconHotel />
                                <span>Khách sạn</span>
                            </a>
                        </li>
                        <li className={renderActive(['/ve-may-bay', '/tim-ve-may-bay'])}>
                            <a href={'https://www.vntrip.vn/ve-may-bay'}>
                                <IconFlight />
                                <span>Vé máy bay</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://quickstay.vntrip.vn/" target="_blank" rel="noopener noreferrer">
                                <IconMotel />
                                <span>Nhà nghỉ</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://tms.vntrip.vn" target="_blank" rel="noopener noreferrer">
                                <IconBusiness />
                                <span>Doanh nghiệp</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.vntrip.vn/cam-nang" target="_blank" rel="noopener noreferrer">
                                <IconBlog />
                                <span>Cẩm nang</span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    )
}

export default HeaderNav
